import {Component, inject} from "@angular/core";
import { AuthService } from "../../../services/auth/auth.service";

@Component({
    selector: 'xplorer-bowser-logout-page',
    templateUrl: './logout-page.component.html',
    styleUrls: ['./logout-page.component.css'],
    standalone: true
})
export class LogoutPageComponent {
  private readonly authService = inject(AuthService);

  constructor() {
    this.authService.logout(`${window.location.origin}/`);
  }

}
